import React from 'react';

import { ModelDetails } from '~/features/x-ray/ModelDetails';

const Page = () => {
  return <ModelDetails />;
};

export default Page;
